import { render, staticRenderFns } from "./rankingBoard.vue?vue&type=template&id=58a424dd&scoped=true&"
import script from "./rankingBoard.vue?vue&type=script&lang=js&"
export * from "./rankingBoard.vue?vue&type=script&lang=js&"
import style0 from "./rankingBoard.vue?vue&type=style&index=0&id=58a424dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a424dd",
  null
  
)

export default component.exports